<template>
  <div class="container mt-md-5 col-md-6 p-4">
    <div class="row">
      <h2 class="text-uppercase">{{ $t('player.playerList') }}</h2>

      <div v-if="players" class="col-12">

        <!-- Starters -->
        <div v-if="players.length > 0"
             class="row column-gap-1 mb-4">
          <div class="col-12 gy-3">
            <div class="row g-0 column-gap-1 align-items-center">
              <div class="col text-uppercase m-0">{{ $t('player.name') }}</div>
              <div class="col-1 p-0 text-center">{{ $t('player.mf') }}</div>
              <div class="col-1 p-0 text-center">{{ $t('player.numbershort') }}</div>
              <div class="col-1 p-0 text-center"></div>
            </div>
          </div>
          <div v-for="player in players"
               :key="player.id"
               class="col-12 gy-3">
            <div class="row g-0 column-gap-1 align-items-center">
              <div @click="openPlayerDetail(player.id)" class="col row g-0 column-gap-1 align-items-center">
                <div class="col bg-bb5-yellow px-1 py-2">{{ player.name }}</div>
                <div class="col-1 bg-bb5-yellow py-2 text-uppercase text-center">{{ player.gender }}</div>
                <div class="col-1 bg-bb5-yellow py-2 text-center">{{ player.number }}</div>
              </div>
              <button class="col-1 btn-danger m-0 py-2" @click="delPlayer(player.id)">X</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <p>{{ $t('player.noPlayers') }}</p>
      </div>
      <div class="col-12">
        <button @click="back" class="col-6 btn btn-bb5-black m-0 p-2">{{ $t('back') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {deletePlayer, loadAllPlayers} from '@/services/indexedDB';

export default {
  name: 'Players',
  data() {
    return {
      players: [],
    };
  },
  async mounted() {
    this.players = await loadAllPlayers();
  },
  methods: {
    async delPlayer(playerId) {
      await deletePlayer(
          playerId
      );
      this.players = this.players.filter(player => player.id !== playerId);
    },
    back() {
      this.$router.push('/');
    },
    openPlayerDetail(playerId) {
      this.$router.push({ name: "PlayerDetail", params: { playerId } });
    },
  }
};
</script>

<style scoped>
</style>
